import React from 'react'
import { NextPage } from 'next'
import { wrapper } from 'src/redux'
import { useTranslation } from 'react-i18next'
import { Box, Heading } from '@chakra-ui/react'
import { Head, LinkRel, MetaTags } from 'src/components/common'
import { getVantaggiNltData } from 'src/utils/getStaticProps'
import { Breadcrumb } from 'src/components/common/StructuredData'

interface Props {
  content: Landing.Page
}

const VantaggiNltPage: NextPage<Props> = ({ content }) => {
  const { t } = useTranslation()

  return <Box bgColor="baseBackgroundLight" mt="m">
    <Breadcrumb breadcrumbData={[
      {
        page: 'Home Page',
        href: '/',
        title: 'Home Page',
      },
      {
        page: 'Offerte Noleggio a Lungo Termine',
        href: '/noleggio-a-lungo-termine',
        title: 'Offerte Noleggio a Lungo Termine',
      },
      {
        page: t(`vantaggiDelNoleggioALungoTerminePage:title`),
        href: '/noleggio-a-lungo-termine/vantaggi',
        title: t(`vantaggiDelNoleggioALungoTerminePage:title`),
      },
    ]} />
    <Box maxW="6xl" pt="0" pb="xxl" mx="auto" px="m">
      <Head title={t(`vantaggiDelNoleggioALungoTerminePage:title`)} />
      <MetaTags meta={t(`vantaggiDelNoleggioALungoTerminePage:meta`, { returnObjects: true })} />
      <LinkRel rel="canonical" href="https://www.carplanner.com/noleggio-a-lungo-termine/vantaggi" />

      <Heading as="h1" fontSize="2xl" fontFamily="Montserrat-SemiBold" color="baseDark" textAlign="left">
        {content.title}
      </Heading>
      <Box
        textAlign="left"
        fontFamily="Montserrat-Regular"
        color="baseDark"
        className="landing-text"
        dangerouslySetInnerHTML={{ __html: content.text }}
      />
    </Box>
  </Box>
}

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  const content = await getVantaggiNltData()

  return { props: { ...content }, revalidate: 60 * 5 }
})

export default VantaggiNltPage
